/*
 * OPJ Modal Scroll Lock
 * Prevents background page scroll when the OPJ personalization modal is open.
 * 
 * How it works:
 *   - Watches #jl-custom-popup (OPJ's modal container) for visibility changes
 *   - When modal opens: locks body scroll (overflow:hidden + position:fixed for iOS)
 *   - When modal closes: restores body scroll and previous scroll position
 *
 * Fully standalone — loaded only on personalize product template.
 * Wrapped in try-catch so it cannot break anything.
 */
(function () {
  'use strict';
  try {
    var scrollY = 0;

    function lockScroll() {
      scrollY = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    }

    function unlockScroll() {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    function init() {
      var popup = document.getElementById('jl-custom-popup');
      if (!popup) return;

      /* ── viewport-height fix (scoped to this element only) ────────
       * OPJ sets height:100vh which on mobile includes the area behind
       * the browser toolbar, hiding the Add-to-Cart button.
       * Apply dvh directly to the found elements — no global CSS. */
      popup.style.setProperty('height', '100dvh', 'important');
      popup.style.setProperty('overscroll-behavior', 'contain', 'important');
      var popupContent = popup.querySelector('.jl-popup-content');
      if (popupContent) {
        popupContent.style.setProperty('height', '100dvh', 'important');
        popupContent.style.setProperty('overscroll-behavior', 'contain', 'important');
      }
      var designWrapper = popup.querySelector('.jl-design-wrapper');
      if (designWrapper) {
        designWrapper.style.setProperty('overscroll-behavior', 'contain', 'important');
      }

      // Use MutationObserver to detect when OPJ shows/hides the modal
      // OPJ toggles display:none and adds .show to .jl-popup-content
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          if (m.type === 'attributes') {
            var isVisible = popup.style.display !== 'none' && popup.style.display !== '';
            if (isVisible) {
              lockScroll();
            } else {
              unlockScroll();
            }
            return; // Only need to process one relevant mutation
          }
        }
      });

      observer.observe(popup, {
        attributes: true,
        attributeFilter: ['style']
      });

      // Also intercept the button click as a backup trigger
      var btn = document.getElementById('jl-custom-button');
      if (btn) {
        btn.addEventListener('click', function () {
          // Small delay to let OPJ show the popup first
          setTimeout(function () {
            if (popup.style.display !== 'none') {
              lockScroll();
            }
          }, 50);
        });
      }

      // Intercept jlClosePopup if it exists — wrap it to ensure unlock
      if (typeof window.jlClosePopup === 'function') {
        var originalClose = window.jlClosePopup;
        window.jlClosePopup = function () {
          originalClose.apply(this, arguments);
          // Small delay to let OPJ finish its close animation
          setTimeout(unlockScroll, 350);
        };
      }
    }

    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      // OPJ loads via defer, so wait a tick for it to render
      setTimeout(init, 500);
    }

    // Failsafe: re-try init after 3s in case OPJ renders late
    setTimeout(function () {
      var popup = document.getElementById('jl-custom-popup');
      if (popup && !popup._scrollLockBound) {
        popup._scrollLockBound = true;
        init();
      }
    }, 3000);

  } catch (e) {
    // If anything goes wrong, silently fail — page continues normally
  }
})();
